import ApplicationJSONAPISerializer from 'district-ui-client/serializers/application'

export default class extends ApplicationJSONAPISerializer {
  modelNameFromPayloadKey(payloadKey) {
    const modelName = {
      // payload-key: model-name,
    }[payloadKey]
    return modelName ?? super.modelNameFromPayloadKey(payloadKey) // handles districts -> district
  }
}
